
import React from 'react';

const OpenRatesSection = () => {
  return (
    <div className="bg-gray-50 rounded-lg p-8 mb-12 shadow-xl">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">How To Hit 30% Open Rates While Sending 10,000+ Emails Per Campaign</h2>
      
      <div className="mt-8">
        <img 
          src="/lovable-uploads/7e66cfdc-da5c-4f26-bd31-80fc1cd4240d.png" 
          alt="Email campaign analytics dashboard showing high open rates across multiple days with metrics for sent, opened, clicked, replied and bounced emails" 
          className="rounded-lg shadow-xl max-w-full mx-auto"
        />
      </div>
    </div>
  );
};

export default OpenRatesSection;
